
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 440 440","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M219.68 90c2.641 0 5.119.643 7.395 1.937 2.267 1.41 4.055 3.2 5.194 5.349l132.97 230.61.088.132.082.135c1.288 2.291 1.951 4.764 1.951 7.265 0 2.542-.652 4.954-1.97 7.298-1.224 2.092-2.953 3.9-4.926 5.143l-.178.1-.18.088c-2.33 1.28-4.726 1.943-7.297 1.943H86.613c-2.596 0-5.073-.68-7.35-1.972-2.199-1.291-4.053-3.148-5.226-5.292-1.363-2.3-2.037-4.725-2.037-7.308 0-2.393.607-4.734 1.795-6.885L207.094 97.281c1.273-2.195 2.932-3.893 5.066-5.22l.167-.093.19-.095c2.124-1.23 4.585-1.873 7.163-1.873zm0 11.285c-.49 0-1 .113-1.501.342l-.263.13c-.3.21-.626.542-.933.956l-.151.214-63.818 110.84-69.271 120.01c-.277.485-.412 1.044-.412 1.651 0 .554.091.99.287 1.37l.09.161.18.315c.282.456.63.787 1.04 1.009.36.196.866.332 1.437.363l.248.007H352.81c.65 0 1.211-.133 1.778-.388.383-.298.666-.606.876-.963l.17-.312.182-.286c.223-.384.339-.83.339-1.276 0-.453-.12-.922-.367-1.369l-.199-.335-.073-.152-.06-.157-133.09-230.77a3.015 3.015 0 00-.99-.957c-.437-.256-1.016-.403-1.695-.403zm11.286 176.298c3.13 0 5.697 2.54 5.697 5.642v24.478c0 3.101-2.568 5.642-5.697 5.642h-22.385c-3.176 0-5.697-2.525-5.697-5.642v-24.478c0-3.118 2.521-5.642 5.697-5.642h22.385zm-5.634 11.284h-11.18v13.131h11.18v-13.13zm6.757-120.062c3.129 0 5.634 2.478 5.634 5.58v.437l-1.622 88.738c-.091 2.826-2.276 5.156-4.996 5.475l-.153.043a2.083 2.083 0 01-.485.057h-21.762c-3.143 0-5.634-2.555-5.634-5.705v-.218l-1.373-88.92c.025-3.012 2.539-5.487 5.573-5.487h24.818zm-5.737 11.284h-13.29l1.184 77.699h10.627l1.48-77.699z","fill-rule":"nonzero","fill":"currentColor"}})])
          )
        }
      }
    